import apiClient from "./fetch";
import { baseURL } from "../utils/constants";

export type WhatsNewItem = {
  feature_id: string;
  feature_name: string;
  description: string; // Quill HTML
  video_url?: string;
  image_url?: string;
  category?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  summary?: string;
};

export type WhatsNewListResponse = {
  status: number;
  data: WhatsNewItem[];
};

export const getWhatsNew = async (params?: {
  from?: number;
  to?: number;
  category?: string;
  is_active?: boolean;
}) => {
  try {
    const res = await apiClient.get<WhatsNewListResponse>(
      `${baseURL}/feature-rollout/whatsnew`,
      { params }
    );
    return res;
  } catch (error: any) {
    if (error.response || error.response?.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

export const getWhatsNewById = async (featureId: string) => {
  try {
    const res = await apiClient.get(`${baseURL}/feature-rollout/whatsnew/${featureId}`);
    return res;
  } catch (error: any) {
    if (error.response || error.response?.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};


